export default {
  badge: 'Insigne',
  open: 'Openen',
  close: 'Sluiten',
  dismiss: 'Negeren',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Annuleren',
  },
  dataIterator: {
    noResultsText: 'Geen overeenkomende resultaten gevonden',
    loadingText: 'Bezig met laden...',
  },
  dataTable: {
    itemsPerPageText: 'Rijen per pagina:',
    ariaLabel: {
      sortDescending: 'Aflopend gesorteerd.',
      sortAscending: 'Oplopend gesorteerd.',
      sortNone: 'Niet gesorteerd.',
      activateNone: 'Activeer om de sortering te verwijderen.',
      activateDescending: 'Activeer om aflopend te sorteren.',
      activateAscending: 'Activeer om oplopend te sorteren.',
    },
    sortBy: 'Sorteer op',
  },
  dataFooter: {
    itemsPerPageText: 'Aantal per pagina:',
    itemsPerPageAll: 'Alles',
    nextPage: 'Volgende pagina',
    prevPage: 'Vorige pagina',
    firstPage: 'Eerste pagina',
    lastPage: 'Laatste pagina',
    pageText: '{0}-{1} van {2}',
  },
  dateRangeInput: {
    divider: 'tot',
  },
  datePicker: {
    itemsSelected: '{0} geselecteerd',
    range: {
      title: 'Selecteer datums',
      header: 'Voer datums in',
    },
    title: 'Selecteer datum',
    header: 'Voer datum in',
    input: {
      placeholder: 'Voer datum in',
    },
  },
  noDataText: 'Geen gegevens beschikbaar',
  carousel: {
    prev: 'Vorige weergave',
    next: 'Volgende weergave',
    ariaLabel: {
      delimiter: 'Carrousel afbeelding {0} van {1}',
    },
  },
  calendar: {
    moreEvents: '{0} meer',
    today: 'Vandaag',
  },
  input: {
    clear: 'Maak {0} leeg',
    prependAction: '{0} voorafgaande actie',
    appendAction: '{0} bijgevoegde actie',
    otp: 'Voer OTP-teken {0} in',
  },
  fileInput: {
    counter: '{0} bestanden',
    counterSize: '{0} bestanden ({1} in totaal)',
  },
  fileUpload: {
    title: 'Sleep en zet bestanden hier neer',
    divider: 'of',
    browse: 'Blader door bestanden',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Selecteer tijd',
  },
  pagination: {
    ariaLabel: {
      root: 'Pagina navigatie',
      next: 'Volgende pagina',
      previous: 'Vorige pagina',
      page: 'Ga naar pagina {0}',
      currentPage: 'Huidige pagina, pagina {0}',
      first: 'Eerste pagina',
      last: 'Laatste pagina',
    },
  },
  stepper: {
    next: 'Volgende',
    prev: 'Vorige',
  },
  rating: {
    ariaLabel: {
      item: 'Beoordeling {0} van {1}',
    },
  },
  loading: 'Bezig met laden...',
  infiniteScroll: {
    loadMore: 'Meer laden',
    empty: 'Geen meer items',
  },
  rules: {
    required: 'Dit veld is verplicht',
    email: 'Voer een geldig e-mailadres in',
    number: 'Dit veld mag alleen nummers bevatten',
    integer: 'Dit veld mag alleen gehele getallen bevatten',
    capital: 'Dit veld mag alleen hoofdletters bevatten',
    maxLength: 'Je mag maximaal {0} tekens invoeren',
    minLength: 'Je moet minimaal {0} tekens invoeren',
    strictLength: 'De lengte van het ingevoerde veld is ongeldig',
    exclude: 'Het teken {0} is niet toegestaan',
    notEmpty: 'Kies ten minste één waarde',
    pattern: 'Ongeldig formaat',
  },
  hotkey: {
    then: 'dan',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Pijl omhoog',
    downArrow: 'Pijl omlaag',
    leftArrow: 'Pijl naar links',
    rightArrow: 'Pijl naar rechts',
    backspace: 'Backspace',
    space: 'Spatie',
    plus: 'plus',
    shortcut: 'Toetsenbordsnelkoppeling: {0}',
  },
}
